/* eslint-disable */
const numeral = require("numeral");
import moment from 'moment'

const ValueFormatter = {
    format: (value: any, format: string | null) : string => {
        if (typeof value === 'number') {
            if (ValueFormatter.isDateFormat(format)) {
                return moment(new Date(value)).format(format || '')
            } else if (ValueFormatter.isNumberFormat(format)) {
                return numeral(value).format(format)
            }
        } else if (typeof value === 'string' && ValueFormatter.isDateFormat(format)) {
            const date = ValueFormatter.getDate(value)
            if (date) {
                return moment(date).format(format || '')
            }
        }

        return value
    },
    isDateFormat: (format: string | null) : boolean => {
        if (format) {
            // No bare ',' or ':' here (deliberately, matches every real date format anyway via
            // an actual token letter) - a number format like '0,0.00' was false-positiving as a
            // date format on the comma alone, routing it through moment() instead of numeral().
            return RegExp('[YMDHhmsAa\\-]').test(format)
        }

        return false
    },
    isNumberFormat: (format: string | null) : boolean => {
        if (format) {
            return RegExp('^[0-9,.()$]+$').test(format)
        }

        return false
    },
    getDate: (value: any) : Date | null => {
        if (typeof value === 'number') {
            return new Date(value)
        } else if (typeof value === 'string') {
            const d = moment(value)
            if (d.isValid()) {
                return d.toDate()
            }
        }

        return null
    }
}

export default ValueFormatter
